export const languages = [
  "english",
  "french",
  "german",
  "italian",
  "japanese",
  "korean",
  "portuguese",
  "russian",
  "swedish",
  "spanish",
];
